import Component from './DateRange.vue';

export default Component;
